<template>
  <div class="container text-center">
    <div class="row justify-content-center">
      <div class="col-sm-12 text-center">
        <img class="img-desktop" src="../assets/imgs/desktop-step03.svg" alt="AUTOCOM" />
        <img class="img-mobile3" src="../assets/imgs/desktop-step03.svg" alt="AUTOCOM" />
        <img class="img-tablet3" src="../assets/imgs/desktop-step03.svg" alt="AUTOCOM" />
      </div>

      <div class="col-md-12 text-center info-auto-oferta">

        <div class="col-md-12 info-auto3">
          <h4 class="titulo-principal">OFERTA</h4>
          <h4 class="subtitulo">¡Hemos terminado!</h4>
        </div>

        <div class="oferta-tituloinfo"> <h4 class="titulo-oferta"> {{nombre}}, NO PUDIMOS OBTENER LOS DATOS DE TU VEHÍCULO PARA <br> 
        HACERTE UNA OFERTA</h4> </div>
        <div class="marcaModeloAño oferta-infoauto">{{ marca }} <span style="color:#E63E19;">•</span> {{ modelo }} <span style="color:#E63E19;">•</span> {{ año }}</div>
        <br />
        <br />
        
        <div class="margin-oferta1 col-md-12 text-center">
          <p class="textoagendar mobile">Un asesor se comunicará contigo a la brevedad para ayudarte a obtener la mejor <br>
            oferta garantizada</p>
          <p class="textoagendar desktop">Un asesor se comunicará contigo a la brevedad para ayudarte a obtener la mejor <br>
            oferta garantizada</p>
          <p class="textoagendar tablet">Un asesor se comunicará contigo a la brevedad para ayudarte a obtener la mejor
            oferta garantizada</p>
        </div>
        <br />
        
        <div class="col-md-6 desktop" style="margin-left: 270px">
          <div>
            <button type="button" style="margin-left: 40px" @click.prevent="cancelar()" class="btn-confirm ">
              IR A LA PÁGINA PRINCIPAL
            </button>
          </div>
        </div>

        <div class="col-md-9 tablet" style="margin-left: 90px">
          <div>
            <button type="button" style="margin-left: 40px" @click.prevent="cancelar()" class="btn-confirm">
              IR A LA PÁGINA PRINCIPAL
            </button>
          </div>
        </div>

        <div class="col-md-12 text-center mobile">
          <button type="button" @click.prevent="cancelar()" class="btn-confirm">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "noOferta",

  components: {},

  data() {
    return {
      marca: sessionStorage.getItem("marca"),
      modelo: sessionStorage.getItem("modelo"),
      año: sessionStorage.getItem("anio"),
      oferta: sessionStorage.getItem("oferta"),
      folio: sessionStorage.getItem("folio"),
      modalTipoV: false,
      modalCancelacion: false,
      inspecAgPic: this.imageUrlInspecAg,
      inspecAgHoverPic: this.imageUrlinspecAgHover,
      AgHoverBool: false,
      inspecDomPic: this.imageUrlinspecDom,
      inspecDomHoverPic: this.imageUrlinspecDomHover,
      DomHoverBool: false,
      nombre: sessionStorage.getItem("nombre"),
    };
  },

  methods: {
    cancelar() {
      setTimeout(() => {
        window.location.replace('/');
      }, 150);
    },

  },

  created() { },

  computed: {
    inspecAgHover() {
      if (this.AgHoverBool == true) {
        return this.inspecAgHoverPic
      } else {
        return this.inspecAgPic
      }
    },
    inspecDomHover() {
      if (this.DomHoverBool == true) {
        return this.inspecDomHoverPic
      } else {
        return this.inspecDomPic
      }
    },
    onMounted(){
      window.scrollTo(0, 0)
    }

  }
};
</script>

<style>

</style>
